import LockIcon from '@/assets/icons/lock-md';
import { Text } from '@/components/TextComponent';
import { Box, Column } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { OPTION_BUTTON_HEIGHT, getBorderRadiusStyle } from '@/feature/event-details-sbk/components/OptionButton';

import { MARKET_COLUMN_WIDTH, styles } from './MarketColumn';

type EmptyMarketColumnProps = {
    header: string;
    showHeader: boolean;
    columnIndex: number;
    totalColumns: number;
    totalRows?: number;
};

export const EmptyMarketColumn = ({
    header,
    showHeader,
    columnIndex,
    totalColumns,
    totalRows = 2,
}: EmptyMarketColumnProps) => {
    return (
        <Column width={MARKET_COLUMN_WIDTH}>
            {showHeader ? (
                <Text variant="bodySmall" color="neutral300" textAlign="center">
                    {header}
                </Text>
            ) : null}
            <Box gap="s3" mt={showHeader ? 's12' : 's20'}>
                {Array.from({ length: totalRows }).map((_, rowIndex) => (
                    <Box
                        key={rowIndex}
                        backgroundColor={ds.colorToken.background.neutral.subtler}
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="r8"
                        style={[
                            styles.optionButton,
                            getBorderRadiusStyle(rowIndex, columnIndex, totalRows, totalColumns),
                        ]}
                        height={OPTION_BUTTON_HEIGHT}
                    >
                        <LockIcon />
                    </Box>
                ))}
            </Box>
        </Column>
    );
};
